"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertMissingFootprints = convertMissingFootprints;
const common_1 = require("./common");
function convertMissingFootprints(schematicElements) {
    return (problem) => {
        const designatorUidMap = {};
        const designator = problem.affectedItems
            .filter(({ type }) => type === "element")
            .map((a) => {
            const element = schematicElements[a.uid];
            if (!element)
                return null;
            // Use just the designator (label), fall back to part name if no designator
            const label = (0, common_1.sanitizeDesignator)(element.label || element.part_version_data_cache?.name);
            if (label) {
                designatorUidMap[label] = a.uid;
            }
            return label;
        })
            .filter((label) => label !== null)
            .join(", ");
        return { name: designator, designator: designator, designatorUidMap };
    };
}
//# sourceMappingURL=missingFootprints.js.map